import React from 'react';
import PropTypes from 'prop-types';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const extractedEpisodeId = (url) => {
  const episode = url.match(/.*\/(.*)\/(.*)\?(.*)$/) || [];
  if (episode && episode.length && episode[2]) {
    return episode[2];
  }
  return null;
};

const SpotifyPlayer = ({
  episodeUrl,
  width = defaultDimensions.width,
  height = defaultDimensions.height,
}) => {
  const episode = extractedEpisodeId(episodeUrl);
  const src = `https://open.spotify.com/embed/episode/${episode}?utm_source=generator`;

  if (!episode) {
    return null;
  }

  return (
    <iframe
      id="spotify-iframe"
      src={src}
      width={width || defaultDimensions.width}
      height={height || defaultDimensions.height}
      frameBorder="0"
      title="Spotify Podcast"
    />
  );
};

SpotifyPlayer.propTypes = {
  episodeUrl: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

SpotifyPlayer.defaultProps = {
  episodeUrl: '',
  width: '',
  height: '',
};

export default SpotifyPlayer;
